export async function api<T = any>(path: string, opts: { method?: string; body?: any; form?: FormData } = {}): Promise<T> {
  const res = await fetch(path, {
    method: opts.method || (opts.body || opts.form ? "POST" : "GET"),
    headers: opts.body ? { "Content-Type": "application/json" } : undefined,
    body: opts.form ?? (opts.body ? JSON.stringify(opts.body) : undefined),
    credentials: "same-origin",
  });
  let data: any = null;
  try { data = await res.json(); } catch {}
  if (!res.ok) throw new Error(data?.error || `Request failed (${res.status})`);
  return data;
}

export interface Asset { id: string; name: string; kind: "image" | "audio"; file: string; size: number; folder: string; created: number }
export const assetUrl = (a: Asset) => `/files/${a.file}`;

export async function uploadFile(file: File, folder = ""): Promise<Asset & { url: string }> {
  const form = new FormData();
  form.append("file", file);
  form.append("folder", folder);
  const r = await api("/api/assets", { form });
  return r.asset;
}
